/* tslint:disable */

/* eslint-disable */
// @ts-nocheck

/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull pos-online-qa-web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/implementation/pos-online-qa-web)
 */
import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'posonlineqa';

export const ApiKey: Record<Environment, string> = {
  posonlineqa: '5b8e3596d82f747ac11d0e5a8b8854b2',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'pos-online-qa-web',
    versionId: '54a19833-9c21-46ab-aff2-cd1ffa6833e4',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface ApplicationCreatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id: string;
  merchant_url?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface CalculatorOpenedProperties {
  merchant_url?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export interface WebApplicationFinishedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  application_id: string;
  merchant_url?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  wuid: string;
}

export class ApplicationCreated implements BaseEvent {
  event_type = 'application_created';

  constructor(public event_properties: ApplicationCreatedProperties) {
    this.event_properties = event_properties;
  }
}

export class CalculatorOpened implements BaseEvent {
  event_type = 'calculator_opened';

  constructor(public event_properties: CalculatorOpenedProperties) {
    this.event_properties = event_properties;
  }
}

export class WebApplicationFinished implements BaseEvent {
  event_type = 'web_application_finished';

  constructor(public event_properties: WebApplicationFinishedProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * application_created
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/application_created)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  applicationCreated(
    properties: ApplicationCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApplicationCreated(properties), options);
  }

  /**
   * calculator_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/calculator_opened)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. merchant_url)
   * @param options Amplitude event options.
   */
  calculatorOpened(
    properties: CalculatorOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CalculatorOpened(properties), options);
  }

  /**
   * web_application_finished
   *
   * [View in Tracking Plan](https://data.amplitude.com/breeze-ventures/POS%20Online%20QA/events/main/latest/web_application_finished)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. application_id)
   * @param options Amplitude event options.
   */
  webApplicationFinished(
    properties: WebApplicationFinishedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WebApplicationFinished(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
